const updateShipAidLogoSVG = () => {
  // Update SVG Inside ShipAid Widget
  const widgetGenerated = document.querySelector('shipaid-widget');
  
  if(widgetGenerated){

    // Toggle Custom
    // const toggleDiv = widgetGenerated.shadowRoot.querySelector('.shipaid-toggle');
    // if(toggleDiv){
    //   toggleDiv.setAttribute('style', 'scale: 0.75;margin-right: -5px;')
    // }
    // Benefits Custom
    const benefitsDiv = widgetGenerated.shadowRoot.querySelector('.shipaid-benefits-container');
    if(benefitsDiv){
      benefitsDiv.setAttribute('style', 'color: white !important;')
    }
  }
}

let visitorCountry = null;

async function fetchCountry() {
  try {
    const res = await fetch("https://ipinfo.io/json");
    const data = await res.json();
    visitorCountry = data.country;
  } catch (e) {
    console.error("Failed to fetch country", e);
  }
}

fetchCountry();

const watchRebuyCartLoad = setInterval(function() {

    if (!visitorCountry) return; // wait until country is loaded
    console.log("Visitor Country", visitorCountry)
    const country = visitorCountry;

    const allowedCountries = [
      "GB","US","CA","AU","NZ","SG","NO","CH"
    ];
    
    const euCountries = [
      "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR",
      "DE","GR","HU","IE","IT","LV","LT","LU","MT","NL",
      "PL","PT","RO","SK","SI","ES","SE"
    ];

    const validCountries = [...allowedCountries, ...euCountries];
    
    if (!validCountries.includes(country)) {
      clearInterval(watchRebuyCartLoad);
      return;
    }
  
    const existingShipAidEle = document.querySelector("shipaid-widget");
    if (existingShipAidEle) {
      clearInterval(watchRebuyCartLoad);
      return;
    }

    const customDiv1 = document.createElement('div');
    customDiv1.style.setProperty("margin-bottom", "0");
    customDiv1.style.setProperty("margin-top", "10px");
    
    let subtitleFont = '11px';
    if (window.innerWidth <= 768) {
      subtitleFont = '10px';
    }

    customDiv1.innerHTML = `
      <shipaid-widget disableRefresh currency=${window.Shopify?.currency?.active}
      style="--shipaid-text: #FFF; --shipaid-text-description: #595C5E;--shipaid-toggle-active: #00AEEF; --shipaid-prompt-actions-price-color: #4F4F4F; --shipaid-prompt-actions-button-color: #00AEEF; --shipaid-prompt-width: 100%; --shipaid-prompt-badge-border-radius: 0px; --shipaid-prompt-footer-button-size: 5px; --shipaid-font-xs: 8px; --shipaid-footer-badge-logo-height: 8px; --shipaid-prompt-footer-location: flex-end; --shipaid-prompt-product-actions-content: start; --shipaid-prompt-footer-topMargin: -8px; --shipaid-prompt-footer-display: none;--shipaid-prompt-margin: -30px 0 -5px 0">
      <span slot="title">Order Protection</span>
      <p slot="subtitle" style="font-size:${subtitleFont}">
      Instant replacement if lost, stolen or damaged.
      </p>
      </shipaid-widget>
    `;

    const targetDiv = document.getElementById('rebuy-cart');

    if (targetDiv) {
      const children1 = targetDiv.children[0];
      if (children1) {
        const children2 = children1.children[2];
        if (children2) {
          const children3 = children2.children[2];
          if (children3) {
            children3.after(customDiv1);

            setTimeout(() => {
              updateShipAidLogoSVG();
            }, 2500);

            clearInterval(watchRebuyCartLoad);
          }
        }
      }
    }

}, 3000);

const events = [
  'shipaid:protection:added',
  'shipaid:protection:removed',
  'shipaid:cart:updated',
  'shipaid:widget:loaded'
];

events.forEach(event => {
  document.addEventListener(event, updateShipAidLogoSVG);
});

